module.exports = __webpack_public_path__ + "media/images/bg_groups-5b1e98c2327aabafe7a9b08cbf1f447e.svg";